import { useCallback } from "react";

import { logger } from "@/lib/logger";

import { useSignOut } from "./use-sign-out";

/**
 * "Not you?" on a shared device: sign the device out (2 Oct).
 *
 * Handing over by only clearing the name kept the sign-in, and a kiosk
 * sign-in may open every ticket raised during it, so the next person could
 * read the previous person's. Signing out starts a fresh sign-in for them
 * (the account picker shows, as after any sign-out) and clears the name.
 */
export function useKioskNotYou(): () => void {
  const { signOut } = useSignOut();

  return useCallback(() => {
    logger.debug("[kiosk] not you: signing the device out");
    void signOut();
  }, [signOut]);
}
